import { fetchAffiliateCartById, createAffiliateCart } from './middleware-api.js';

function checkDiscountGroupsBeforeCheckout() {
  const checkboxes = document.querySelectorAll('.cart-item-checkbox');
  const discountGroups = {};

  checkboxes.forEach(cb => {
    const groups = (cb.dataset.discountGroup || '').split(',').filter(Boolean);
    groups.forEach(group => {
      if (!discountGroups[group]) discountGroups[group] = [];
      discountGroups[group].push(cb);
    });
  });

  const incompleteGroups = [];
  for (const group in discountGroups) {
    const items = discountGroups[group];
    const total = items.length;
    const checked = items.filter(cb => cb.checked).length;
    if (checked > 0 && checked < total) {
      incompleteGroups.push(group);
    }
  }

  if (incompleteGroups.length > 0) {
    const groupNames = incompleteGroups.map(g => g.replace(/-/g, ' ')).join(', ');
    const confirmContinue = confirm(`You're missing items from discount group(s): ${groupNames}. The discount may not apply. Continue checkout?`);
    if (!confirmContinue) return false; // prevent checkout
  }

  return true;
}


function updateSubtotal() {
  let subtotal = 0;

  document.querySelectorAll('.cart-item-checkbox').forEach(cb => {
    if (cb.checked) {
      const price = parseFloat(cb.dataset.final);
      subtotal += price;
    }
  });

  const subtotalDisplay = document.querySelector('#subtotal-display');
  if (subtotalDisplay) {
    subtotalDisplay.textContent = formatMoney(subtotal);
  }
  if (typeof updateFreeShippingBar === 'function') {
    updateFreeShippingBar(subtotal);
  }
}

function formatMoney(amount) {
  if (amount == null) return 'N/A';
  const format = window.ShopifyMoney?.format || "${{amount}}";
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const value = parseFloat(amount).toFixed(2);
  return format.replace(placeholderRegex, value);
}

function showErrorModal(message) {
  const modal = document.getElementById('error-modal');
  const modalMsg = document.getElementById('modal-message');
  modalMsg.textContent = message;
  modal.classList.remove('hidden');

  modal.querySelector('.modal-close').addEventListener('click', () => {
    modal.classList.add('hidden');
  });

  modal.addEventListener('click', (e) => {
    if (e.target === modal) modal.classList.add('hidden');
  });
}

function showAffiliateModal(data) {
  const modal = document.getElementById('affiliate-modal');
  const input = document.getElementById('affiliate-link-input');
  input.value = data;
  modal.classList.remove('hidden');

  modal.querySelector('.modal-close').addEventListener('click', () => {
    modal.classList.add('hidden');
  });

  modal.addEventListener('click', (e) => {
    if (e.target === modal) modal.classList.add('hidden');
  });
}

function updateButtonState() {
  const selectAllCheckbox = document.getElementById('select-all-checkbox');
  // const itemCheckboxes = Array.from(document.querySelectorAll('.cart-item-checkbox')).filter(el => el.getAttribute('data-final') !== '0.00');
  const itemCheckboxes =  document.querySelectorAll('.cart-item-checkbox');
  const checkoutBtn = document.getElementById('checkout-selected-btn');
  const bulkDeleteBtn = document.getElementById('bulk-delete-btn');
  const shareCartBtn = document.getElementById('share-cart-btn');
  
  const anyChecked = Array.from(itemCheckboxes).some(cb => cb.checked);
  bulkDeleteBtn.disabled = !anyChecked;
  checkoutBtn.classList.toggle("disabled", !anyChecked);
  if(shareCartBtn) {
     shareCartBtn.disabled = !anyChecked; 
  }
};

function generateItemKey(item) {
  const props = item.properties || {};
  const propsString = Object.keys(props)
    .sort()
    .map(key => `${key}:${props[key]}`)
    .join('|');

  return `${item.variant_id || item.productVariantId}|${propsString}`;
}

async function restoreAffiliateCart(id) {
  const loadingEle = document.getElementById("cart-loading")
  const loadingMsgEle = loadingEle.querySelector('.loading-message');
  const affiliateCartRes = await fetchAffiliateCartById(id);
  const affiliateCartItems = affiliateCartRes.cartItems || [];
  const currentCart = await fetch('/cart.js').then(res => res.json()).then(data => data.items);

  const currentKeys = new Set(currentCart.map(generateItemKey));

  const missingItems = affiliateCartItems.filter(item => {
    const key = generateItemKey({ variant_id: item.variant_id, properties: item.properties });
    return !currentKeys.has(key);
  });

  if (missingItems.length > 0) {
    loadingMsgEle.textContent = 'Retrieving affiliate cart, please wait...';
    loadingEle.classList.remove("hidden");
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: missingItems.map(({ productVariantId, quantity }) => ({ id: productVariantId, quantity: quantity }))
      })
    });

    // Attach share cart ID as cart attribute
    await addAffilateCartAttribute(id);
    
    setTimeout(() => {
      saveCartToServer(); 
      loadingMsgEle.textContent = '';
      loadingEle.classList.add("hidden");
      window.location.href = '/cart';
    }, 1000);    
  } else {
    console.log('affiliate carrt already synced.');
    loadingMsgEle.textContent = '';
    loadingEle.classList.add("hidden");
  }
}

async function addAffilateCartAttribute(id) {
  try {
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          referenceCode: id,
        },
      }),
    });

  } catch (error) {
    console.error('Failed to attach affiliateCartCode:', error);
  }
}


document.addEventListener('change', function (e) {
  if (e.target.matches('#select-all-checkbox')) {
    // const checkboxes = Array.from(document.querySelectorAll('.cart-item-checkbox')).filter(el => el.getAttribute('data-final') !== '0.00');
    const checkboxes = document.querySelectorAll('.cart-item-checkbox');
    checkboxes.forEach(cb => cb.checked = e.target.checked);
    updateButtonState();
    updateSubtotal();
  }

  if (e.target.matches('.cart-item-checkbox')) {
    // const checkboxes = Array.from(document.querySelectorAll('.cart-item-checkbox')).filter(el => el.getAttribute('data-final') !== '0.00');
    const checkboxes = document.querySelectorAll('.cart-item-checkbox');
    const selectAll = document.getElementById('select-all-checkbox');

    if (!e.target.checked) {
      selectAll.checked = false;
    } else if (Array.from(checkboxes).every(cb => cb.checked)) {
      selectAll.checked = true;
    }
    updateButtonState();
    updateSubtotal();
  }
});


document.addEventListener('click', async function (e) {
  if (e.target.matches('#bulk-delete-btn')) {
    // const itemCheckboxes = Array.from(document.querySelectorAll('.cart-item-checkbox')).filter(el => el.getAttribute('data-final') !== '0.00');
    const itemCheckboxes = document.querySelectorAll('.cart-item-checkbox');
    const bulkDeleteBtn = document.getElementById('bulk-delete-btn');
    const selectedKeys = Array.from(itemCheckboxes)
      .filter(cb => cb.checked)
      .map(cb => cb.dataset.key);

    if (selectedKeys.length === 0) return;
    bulkDeleteBtn.disabled = true;
    bulkDeleteBtn.textContent = 'Removing...';

    const updates = selectedKeys.reduce((acc, key) => {
      acc[key] = 0;
      return acc;
    }, {});
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    })
    .then(() => {
      selectedKeys.forEach(key => {
        const row = document.querySelector(`tr[data-key='${key}']`);
        if (row) row.remove();
      });
    
      saveCartToServer();
    
      return fetch('/cart.js'); // Fetch updated cart here
    })
    .then(res => res.json())
    .then(cart => {
      // const remainingRows = Array.from(document.querySelectorAll('.cart-item-checkbox')).filter(el => el.getAttribute('data-final') !== '0.00');
      const remainingRows = document.querySelectorAll('.cart-item-checkbox');
      if (remainingRows.length === 0) {
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        const subtotalEl = document.querySelector('.totals__total-value');
        if (subtotalEl) {
          subtotalEl.textContent = formatMoney(cart.total_price);
        }
        bulkDeleteBtn.textContent = 'Remove';
        updateButtonState();
      }
    })
    .catch(err => {
      console.error('Bulk delete failed:', err);
    });
  }

  if (e.target.matches('#checkout-selected-btn')) {
    const itemCheckboxes = document.querySelectorAll('.cart-item-checkbox');
    const checkoutBtn = document.getElementById('checkout-selected-btn');
    const response = await fetch('/cart.js');
    const cart = await response.json();

    const selectedKeys = Array.from(itemCheckboxes)
      .filter(cb => cb.checked)
      .map(cb => cb.dataset.key);

    if (selectedKeys.length === 0) return;

    const selectedItems = cart.items.filter(item => selectedKeys.includes(item.key));
    const unselectedItems = cart.items.filter(item => !selectedKeys.includes(item.key));
    
    checkoutBtn.classList.toggle("disabled", true);
    checkoutBtn.textContent = 'Loading...';

    // Pre-order Validation
    const selectedPreorders = Array.from(itemCheckboxes)
      .filter(cb => cb.checked)
      .map(cb => cb.dataset.preorder);    

    const allSame = selectedPreorders.every(date => date === selectedPreorders[0]);
    if (!allSame) {
      showErrorModal('You can only checkout items with the same pre-order date.');
      checkoutBtn.classList.toggle("disabled", false);
      checkoutBtn.textContent = 'Checkout';
      return;
    }

    if(!checkDiscountGroupsBeforeCheckout()) {
      checkoutBtn.classList.toggle("disabled", false);
      checkoutBtn.textContent = 'Checkout';
      e.preventDefault();
      return;
    }

    let metafieldExceeded = false;
    for (const item of selectedItems) {
      const input = document.querySelector(`input[data-quantity-variant-id='${item.variant_id}']`);
      if (!input) continue;

      let max = null;
      if (input.dataset.maxMetafield) {
        const parsed = parseInt(input.dataset.maxMetafield);
        if (!isNaN(parsed) && parsed > 0) {
          max = parsed;
        }
      }
      if (max !== null && item.quantity > max) {
        showErrorModal(`Item "${item.product_title}" exceeds the allowed quantity (${max}). Please adjust it before checking out.`);
        metafieldExceeded = true;
        break;
      }
    }

    if (metafieldExceeded) {
      checkoutBtn.classList.toggle("disabled", false);
      checkoutBtn.textContent = 'Checkout';
      return;
    }

    // Store unselected items in localStorage
    const toRestore = unselectedItems.map(item => ({
      id: item.variant_id,
      quantity: item.quantity,
      properties: item.properties || {},
      selling_plan: item.selling_plan_allocation?.selling_plan?.id || undefined,
    }));
    localStorage.setItem('restore_after_checkout', JSON.stringify(toRestore));

    // Clear full cart first
    await fetch('/cart/clear.js', { method: 'POST' });

    // Add selected items only
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: selectedItems.map(item => ({
          id: item.variant_id,
          quantity: item.quantity,
          properties: item.properties || {},
          selling_plan: item.selling_plan_allocation?.selling_plan?.id || undefined,
        }))
      })
    });

    window.location.href = '/checkout';
    checkoutBtn.classList.toggle("disabled", false);
    checkoutBtn.textContent = 'Checkout';
  }

  if (e.target.matches('#share-cart-btn')) {
    const itemCheckboxes = document.querySelectorAll('.cart-item-checkbox');
    const shareCartBtn = document.getElementById('share-cart-btn');
    const loadingEle = document.getElementById("cart-loading")
    const loadingMsgEle = loadingEle.querySelector('.loading-message');
    loadingMsgEle.textContent = 'Generating affiliate link for cart, please wait...';
    loadingEle.classList.remove("hidden");
    
    const selectedKeys = Array.from(itemCheckboxes)
      .filter(cb => cb.checked)
      .map(cb => cb.dataset.key);

    const cartData = await fetch('/cart.js').then(res => res.json());
    const selectedItems = cartData.items.filter(item => selectedKeys.includes(item.key));
    const cartItems = selectedItems.map(item => ({
      productVariantId: `${item.variant_id}`,
      productTitle: `${item.product_title}`,
      quantity: item.quantity,
    }));

    try {
      const affiliateCartRes = await createAffiliateCart(cartItems);
      showAffiliateModal(affiliateCartRes.affiliateLink);
      loadingEle.classList.add("hidden");
    } catch (error) {
      loadingEle.classList.add("hidden");
      showErrorModal('Failed to create affiliate link. Please try again.');
    }
  }
});

// restore the cart item
document.addEventListener('DOMContentLoaded', async () => {
  const restoreData = localStorage.getItem('restore_after_checkout');
  const loadingEle = document.getElementById("cart-loading")
  const loadingMsgEle = loadingEle.querySelector('.loading-message');
  if (!restoreData) return;
  loadingMsgEle.textContent = 'Restoring your cart, please wait...';
  loadingEle.classList.remove("hidden");

  try {
    const toRestore = JSON.parse(restoreData);
    if (!Array.isArray(toRestore) || toRestore.length === 0) {
      localStorage.removeItem('restore_after_checkout');
      loadingMsgEle.textContent = 'Restoring your cart, please wait...';
      loadingEle.classList.add("hidden");
      return;
    }

    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();

    const itemsToAdd = [];

    toRestore.forEach(restoreItem => {
      const alreadyInCart = cart.items.some(cartItem => {
        const sameId = cartItem.variant_id === restoreItem.id;

        const props1 = cartItem.properties || {};
        const props2 = restoreItem.properties || {};

        const keys1 = Object.keys(props1).sort();
        const keys2 = Object.keys(props2).sort();

        if (keys1.length !== keys2.length) return false;
        for (let i = 0; i < keys1.length; i++) {
          const key = keys1[i];
          if (key !== keys2[i] || props1[key] !== props2[key]) return false;
        }

        return sameId;
      });

      if (!alreadyInCart) itemsToAdd.push(restoreItem);
    });

    if (itemsToAdd.length === 0) {
      localStorage.removeItem('restore_after_checkout');
      loadingMsgEle.textContent = 'Restoring your cart, please wait...';
      loadingEle.classList.add("hidden");
      return;
    }

    for (const item of itemsToAdd) {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: item.id,
          quantity: item.quantity,
          selling_plan: item.selling_plan || undefined,
          properties: item.properties || {}
        })
      });
    }

    localStorage.removeItem('restore_after_checkout');
    window.location.reload();

  } catch (error) {
    console.error('Restore failed:', error);
    localStorage.removeItem('restore_after_checkout');
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const params = new URLSearchParams(window.location.search);
  const affiliateCartId = params.get('referenceCode');
    
  if (affiliateCartId) {
    restoreAffiliateCart(affiliateCartId);
  }

  const userType = localStorage.getItem('userType');
  if(userType == 'Staff') {
    const shareCartBtn = document.getElementById('share-cart-btn');
    if(shareCartBtn) {
      shareCartBtn.classList.remove('hidden');
    }
  }

  // bind copy function
  document.getElementById('copy-affiliate-link').addEventListener('click', () => {
    const input = document.getElementById('affiliate-link-input');
    input.select();
    document.execCommand('copy');
    document.getElementById('affiliate-link-msg').textContent = "Link copied to clipboard!";
    setTimeout(() => {
      document.getElementById('affiliate-link-msg').textContent = "";
    }, 2000);
  });
});